module.exports = __webpack_public_path__ + "img/img_test_1052.06691087.png";